module.exports = __webpack_public_path__ + "f2f01051.svg";